// Asynchronously import Pages for Routes
import type { RouteRecordRaw } from 'vue-router'
import { ROGUE_APP_SPA_URL_PREFIX } from '@/js/app-bridge/helpers'
import type { IRogue } from '@/js/services/RogueTypes'
import { useCustomerStore } from '@/js/stores/customerStore'
import { useListStore } from '@/js/stores/listStore'

const BazaarvoiceMps = () => import(/* webpackChunkName: "bv-mps" */ 'Src/js/components/bazaarvoice-mps.vue')

const Home = () => import(/* webpackChunkName: "pf-page-home" */ 'Src/js/pages/home/home.vue')
const SearchResults = () => import(/* webpackChunkName: "pf-category" */ 'Src/js/pages/category/SearchResults.vue')
const LogIn = () => import(/* webpackChunkName: "page-login" */ 'Src/js/pages/account/login.vue')
const Cart = () => import(/* webpackChunkName: "page-cart" */ 'Src/js/pages/cart/index.vue')
const Compare = () => import(/* webpackChunkName: "page-compare" */ 'Src/js/pages/compare/compare.vue')

const deals = () => import(/* webpackChunkName: "page-deals" */ 'Src/js/pages/deals/deals.vue')
const brands = () => import(/* webpackChunkName: "page-deals" */ 'Src/js/pages/brands/brands.vue')
const competition = () => import(/* webpackChunkName: "competition" */ 'Src/js/pages/competition/competition.vue')
const orderManagerQuote = () => import(/* webpackChunkName: "quote" */ 'Src/js/pages/order-manager-quote.vue')

const account = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/account.vue')
const accountAddresses = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/address.vue')
const accountDashboard = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/dashboard.vue')
const accountAboutMe = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/about.vue')
const accountProgramming = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/programming/programming.vue')
const accountEarned = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/earned-store.vue')
const accountProgram = () => import(/* webpackChunkName: "programming" */ 'Src/js/pages/account/subroutes/programming/program.vue')
const accountRegistries = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/registry/registry.vue')
const accountRegistryDetails = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/registry/registry-details.vue')
const accountOrders = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/orders.vue')
const accountReviews = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/reviews.vue')
const accountOrderDetail = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/order-detail.vue')
const accountPaymentMethods = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/payment-methods.vue')
const accountWishlist = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/wishlist/wishlist.vue')
const accountBin = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/bin.vue')
const expired = () => import(/* webpackChunkName: "expired" */ 'Src/js/pages/account/expired-password.vue')
const accountResetPassword = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/reset-password.vue')
const accountSettings = () => import(/* webpackChunkName: "page-account" */ 'Src/js/pages/account/subroutes/settings.vue')
const accountRegistryWishlist = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/wishlist-and-registry.vue')
const accountGyms = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/gyms.vue')
const accountWorkoutStatistics = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/workouts.vue')
const customQuoting = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/custom-quoting.vue')
const zeusSavedDesign = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/zeus-saved-design.vue')
const accountMyChallenges = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/my-challenges/my-challenges.vue')
const accountRogueMove = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/account/subroutes/rogue-move/rogue-move.vue')

const activate = () => import('@/js/pages/activate/LinkDevice.vue')

const checkoutLandingV2 = () => import('Src/js/pages/checkout/subroutes/landing.vue')
const CheckoutV2 = () => import('Src/js/pages/checkout/index.vue')
const checkoutShippingV2 = () => import('Src/js/pages/checkout/subroutes/shipping.vue')
const checkoutPaymentV2 = () => import('Src/js/pages/checkout/subroutes/payment.vue')
const checkoutReviewV2 = () => import('Src/js/pages/checkout/subroutes/review.vue')
const checkoutSuccessV2 = () => import('Src/js/pages/checkout/subroutes/success.vue')

const paymentRequest = () => import(/* webpackChunkName: "extrapay" */ 'Src/js/pages/payment-link/index.vue')

const rma = () => import(/* webpackChunkName: "page-rma" */ 'Src/js/pages/rma/rma.vue')
const rmaInitiate = () => import(/* webpackChunkName: "page-rma" */ 'Src/js/pages/rma/subroutes/initiate.vue')
const rmaSelectItems = () => import(/* webpackChunkName: "page-rma" */ 'Src/js/pages/rma/subroutes/select-items.vue')
const rmaConfirm = () => import(/* webpackChunkName: "page-rma" */ 'Src/js/pages/rma/subroutes/confirm.vue')
const rmaPrintReturn = () => import(/* webpackChunkName: "page-rma" */ 'Src/js/pages/rma/subroutes/rma-print-return.vue')

const rbRHPA = () => import(/* webpackChunkName: "roguebuilder" */ 'Src/js/pages/roguebuilder_preview/rhpa.vue')
const rbPreview = () => import(/* webpackChunkName: "roguebuilder" */ 'Src/js/pages/roguebuilder_preview/preview.vue')

const publicRegistry = () => import(/* webpackChunkName:"registry" */ 'Src/js/pages/registry/public-registry.vue')
const searchRegistries = () => import(/* webpackChunkName:"registry" */ 'Src/js/pages/registry/registry-search.vue')
const publicWishlist = () => import(/* webpackChunkName:"shared-wishlist" */ 'Src/js/pages/shared-wishlist/shared-wishlist.vue')

const newsLetterSignupPage = () => import(/* webpackChunkName: "page-cms" */ 'Src/js/pages/cms/newsLetterSignup.vue')

const rss = () => import(/* webpackChunkName: "page-rss" */ 'Src/js/pages/rss/rss.vue')
const gymBuilderDashboard = () => import(/* webpackChunkName: "gym-builder" */ 'Src/js/pages/gym-builder/dashboard.vue')
const gymBuilderMine = () => import(/* webpackChunkName: "gym-builder" */ 'Src/js/pages/gym-builder/subroutes/my-gyms.vue')
const gymBuilderTemplates = () => import(/* webpackChunkName: "gym-builder" */ 'Src/js/pages/gym-builder/subroutes/templates.vue')
const gymBuilderFeatured = () => import(/* webpackChunkName: "gym-builder" */ 'Src/js/pages/gym-builder/subroutes/featured.vue')
const gymBuilderProjectEdit = () => import(/* webpackChunkName: "gym-builder" */ '@/js/pages/gym-builder/subroutes/project-edit.vue')
const gymBuilderProjectView = () => import(/* webpackChunkName: "gym-builder" */ '@/js/pages/gym-builder/subroutes/project-view.vue')
const gymBuilderPoc = () => import(/* webpackChunkName: "gym-builder-poc" */ '@/js/pages/gym-builder/poc/poc.vue')

const theIndexHome = () => import(/* webpackChunkName: "theindex" */ 'Src/js/pages/theindex/index.vue')
const theIndexPost = () => import(/* webpackChunkName: "theindex" */ 'Src/js/pages/theindex/post.vue')
const theIndexCategory = () => import(/* webpackChunkName: "theindex" */ 'Src/js/pages/theindex/category.vue')
const theIndexRYouRogue = () => import(/* webpackChunkName: "theindex" */ 'Src/js/pages/theindex/ryourogue.vue')

const rogueCatalog = () => import(/* webpackChunkName: "rogue-catalog" */ 'Src/js/pages/catalog/catalog.vue')

const rogueGyms = () => import(/* webpackChunkName: "rogue-gyms" */ 'Src/js/pages/rogue-equipped-gyms/index.vue')

// Native Rogue App routes
const nativeAppPreloader = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-preloader.vue')
const nativeAppExclusive = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-exclusive.vue')
const nativeAppOrdersScreen = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-orders-screen.vue')
const nativeAppOrderHistoryScreen = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-order-history-screen.vue')
const nativeAppTrackOrdersScreen = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-track-orders-screen.vue')
const nativeAppFeaturesScreen = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-features-screen.vue')
const nativeAppNotifications = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-notifications-screen.vue')
const nativeAppNotificationsPreferences = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-notifications-preferences.vue')
const nativeAppNotificationsRapidfire = () => import(/* webpackChunkName: "rogue-app" */ '@/js/pages/_rg-app/native-app-notifications-rapidfire.vue')
const nativeAppWorkoutsScreen = () => import(/* webpackChunkName: "page-account" */ '@/js/pages/_rg-app/native-app-workouts-screen.vue')
const nativeAppChallengesSchedule = () => import(/* webpackChunkName: "rogue-app-challenges" */ '@/js/pages/_rg-app/challenges/schedule.vue')
const nativeAppChallengesLeaderboard = () => import(/* webpackChunkName: "rogue-app-challenges" */ '@/js/pages/_rg-app/challenges/leaderboard.vue')
const nativeAppChallengesFaq = () => import(/* webpackChunkName: "rogue-app-challenges" */ '@/js/pages/_rg-app/challenges/faq.vue')
const nativeAppChallengesAbout = () => import(/* webpackChunkName: "rogue-app-challenges" */ '@/js/pages/_rg-app/challenges/about.vue')
const nativeAppMyChallenges = () => import(/* webpackChunkName: "rogue-app-challenges" */ '@/js/pages/_rg-app/challenges/my-challenges.vue')
const errorPage = () => import(/* webpackChunkName: "error" */ '@/js/pages/404/404.vue')

const HOMEPAGE_ID = 'homepage_2015'

export function getRoutes(rogue: IRogue): RouteRecordRaw[] {
  // RMA routes should be available for US store only
  const rmaRoutes: RouteRecordRaw = {
    path      : '/rmaprocess',
    component : rma,
    name      : 'rma',
    children  : [
      {
        path      : 'initiate',
        component : rmaInitiate,
        name      : 'rmaInitiate',
      },
      {
        path      : 'select-items',
        component : rmaSelectItems,
        name      : 'rmaSelectItems',
      },
      {
        path      : 'confirm',
        component : rmaConfirm,
        name      : 'rmaConfirm',
      },
      {
        path      : 'print/:rmaNumber?/:dateIssued?',
        component : rmaPrintReturn,
        name      : 'rmaPrintReturn',
      },
    ],
  }

  // Rogue catalog should only be shown in US store
  const catalog: RouteRecordRaw = {
    path      : '/rogue-catalog',
    component : rogueCatalog,
  }

  const zeus: RouteRecordRaw[] = [
    /**
     * Zeus
     */
    {
      path      : '/zeus-builder',
      component : gymBuilderDashboard,
      meta      : {
        // Dont scroll between children
        siblingScroll: false,
      },
      children: [
        {
          path      : '',
          component : gymBuilderFeatured,
          name      : 'Featured Gyms',
        },
        {
          path      : 'templates',
          component : gymBuilderTemplates,
          name      : 'Room Templates',
        },
        {
          path      : 'my-gyms',
          component : gymBuilderMine,
          name      : 'My Gyms',
        },
      ],
    },
    {
      path      : '/zeus-builder/project/edit',
      component : gymBuilderProjectEdit,
    },
    {
      path      : '/zeus-builder/project/:projectId',
      component : gymBuilderProjectView,
    },

  ]

  /**
   * POC: custom Three.js gym builder (does not touch the live Zeus flow).
   *
   * Kept out of `zeus` so it can be registered conditionally — see where this is
   * unshifted below.
   */
  const zeusPoc: RouteRecordRaw = {
    path      : '/zeus-builder/poc',
    component : gymBuilderPoc,
  }

  // Router
  const routes: RouteRecordRaw[] = [
    {
      path      : '/',
      component : Home,
      name      : 'Home',
      meta      : {
        type : 'cms',
        id   : HOMEPAGE_ID,
      },
    },
    {
      path      : '/mps-review',
      component : BazaarvoiceMps,
    },
    {
      path      : '/404',
      component : errorPage,
      name      : 'Page Not Found',
    },
    {
      path      : '/search',
      component : SearchResults,
      name      : 'Search',
      beforeEnter(to) {
        if (!to.query.q) {
          return '/'
        }
      },
    },
    {
      path      : '/newsletter-signup',
      component : newsLetterSignupPage,
      name      : 'Newsletter Signup',
    },
    {
      path      : '/newsletter-error',
      component : newsLetterSignupPage,
      name      : 'Newsletter Error',
    },
    {
      path      : '/cart',
      component : Cart,
      name      : 'Cart',
    },
    {
      path      : '/login',
      component : LogIn,
      name      : 'Log In',
    },
    {
      path: '/customer/account/login',
      beforeEnter() {
        return '/login'
      },
    },
    {
      path      : '/expired-password',
      component : expired,
      name      : 'Expired Password',
    },
    {
      path      : '/compare/:catchAll(.*)',
      component : Compare,
      name      : 'Compare',
    },
    {
      path      : '/payment-link',
      component : paymentRequest,
      name      : 'paymentRequest',
      meta      : {
        isFunneled: true,
      },
    },
    {
      path        : '/account',
      component   : account,
      name        : 'myAccount',
      beforeEnter : async () => {
        const customerStore = useCustomerStore(rogue.pinia)
        await customerStore.init(rogue)
      },
      children: [
        {
          path      : 'dashboard',
          component : accountDashboard,
          name      : 'myAccountDashboard',
        },
        {
          path      : 'earned-store',
          component : accountEarned,
          name      : 'myAccountEarnedStore',
          meta      : {
            allowGuestAppAccess: true,
          },
        },
        {
          path      : 'programming',
          component : accountProgramming,
          name      : 'myAccountProgramming',
        },
        {
          path      : 'programming/:id',
          component : accountProgram,
          name      : 'myAccountProgram',
        },
        {
          path      : 'about-me',
          component : accountAboutMe,
          name      : 'myAccountAboutMe',
        },
        {
          path      : 'orders',
          component : accountOrders,
          name      : 'myAccountOrders',
        },
        {
          path      : 'reviews',
          component : accountReviews,
          name      : 'myAccountReviews',
        },
        {
          path      : 'my-lists',
          component : accountRegistryWishlist,
          name      : 'myAccountRegistriesAndWishlist',
        },
        {
          path      : 'custom-quoting',
          component : customQuoting,
          name      : 'myAccountCustomQuoting',
        },
        {
          path      : 'registry',
          component : accountRegistries,
          name      : 'myAccountRegistries',
        },
        {
          path      : 'registry/:id',
          component : accountRegistryDetails,
          name      : 'myAccountRegistryDetails',
        },
        {
          path      : 'order/:id',
          component : accountOrderDetail,
          name      : 'myAccountOrderDetail',
        },
        {
          path      : 'address',
          component : accountAddresses,
          name      : 'myAccountAddresses',
        },
        {
          path      : 'wishlist',
          component : accountWishlist,
          name      : 'myAccountWishlist',
        },
        {
          path      : 'bin',
          component : accountBin,
          name      : 'myAccountBIN',
        },
        {
          path      : 'payment-methods',
          component : accountPaymentMethods,
          name      : 'myAccountPaymentMethods',
        },
        {
          path      : 'settings',
          component : accountSettings,
        },
        {
          path      : 'my-gyms',
          component : accountGyms,
          name      : 'myAccountGyms',
        },
        {
          path      : 'workout-statistics',
          component : accountWorkoutStatistics,
          name      : 'myAccountWorkoutStatistics',
        },
        {
          path      : 'zeus-saved-design',
          component : zeusSavedDesign,
          name      : 'myAccountZeusSavedDesign',
        },
        {
          path      : 'my-challenges',
          component : accountMyChallenges,
          name      : 'myAccountMyChallenges',
        },
        /*
         * Rogue Move ships behind a flag while it is being built. Not
         * registering the route *is* the gate: with the flag off
         * `/account/rogue-move` is not a route, so the calendar is unreachable
         * and its chunk is never requested.
         *
         * Safe against hydration mismatch for the same reason as
         * `enable-zeus-poc` below: the server passes its feature set into
         * `Rogue` before building routes and serialises the same set to
         * `window.ROGUE.features`, so both sides agree on whether this route
         * exists. Forced flags (`?ab_rogue-move-enabled=1`, `cfab_` headers)
         * are read server-side too, so an override flips both together.
         */
        ...(rogue.featureFlags.isOn('rogue-move-enabled') ? [ {
          path      : 'rogue-move',
          component : accountRogueMove,
          name      : 'myAccountRogueMove',
          meta      : {
            // Calendar spans the full page width, so the account left nav is hidden
            fullWidth: true,
          },
        } ] : []),
      ],
    },
    {
      path      : '/activate',
      component : activate,
      meta      : {
        isFunneled                  : true,
        darkMode                    : true,
        hideChristmasShippingBanner : true,
        hideStaticFooter            : true,
        showSocialFooter            : true,
      },
      name: 'link-device',
    },
    {
      path      : '/account/reset-password/:token',
      component : accountResetPassword,
    },
    {
      path      : '/registry/:urlKey',
      component : publicRegistry,
    },
    {
      path      : '/giftregistry/search/index',
      component : searchRegistries,
    },
    {
      path      : '/wishlist/:urlKey',
      component : publicWishlist,
    },
    {
      path      : '/shippingtracker',
      component : rss,
      name      : 'rss',
    },
    {
      path      : '/__rb__/rhpa',
      component : rbRHPA,
    },
    {
      path      : '/__rb__/preview',
      component : rbPreview,
    },
    {
      path      : '/deals',
      component : deals,
      meta      : {
        type: 'deals',
      },
    },
    {
      path      : '/brands',
      component : brands,
    },

    /**
     * The Index
     */
    {
      path      : '/theindex',
      component : theIndexHome,
      name      : 'IndexHome',
    },
    {
      path      : '/theindex/ryourogue',
      component : theIndexRYouRogue,
      name      : 'IndexRYouRogue',
    },
    {
      path      : '/theindex/:category',
      component : theIndexCategory,
      name      : 'IndexCategory',
    },
    {
      path      : '/theindex/:catchAll(.*)/:slug',
      component : theIndexPost,
      name      : 'IndexPost',
    },

    /**
     * Native Rogue App
     */
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}exclusive/:productId`,
      component : nativeAppExclusive,
      name      : 'nativeAppExclusive',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}preloader`,
      component : nativeAppPreloader,
      name      : 'nativeAppPreloader',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}featured`,
      component : nativeAppFeaturesScreen,
      name      : 'nativeAppFeaturedScreen',
      meta      : {
        isCMSPage         : true,
        removeAboveHeader : true,
        id                : 619,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}orders`,
      component : nativeAppOrderHistoryScreen,
      name      : 'nativeAppOrderHistoryScreen',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}tracking`,
      component : nativeAppTrackOrdersScreen,
      name      : 'nativeAppTrackOrdersScreen',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}account/orders`,
      component : nativeAppOrdersScreen,
      name      : 'nativeAppOrdersScreen',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}account/notifications`,
      component : nativeAppNotifications,
      name      : 'nativeAppNotifications',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}account/workouts`,
      component : nativeAppWorkoutsScreen,
      name      : 'nativeAppWorkouts',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}account/notifications/preferences`,
      component : nativeAppNotificationsPreferences,
      name      : 'nativeAppNotificationsPreferences',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}account/notifications/rapidfire`,
      component : nativeAppNotificationsRapidfire,
      name      : 'nativeAppNotificationsRapidfire',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    /**
     * Native Rogue App - Challenges
     */
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}challenges`,
      component : nativeAppChallengesSchedule,
      name      : 'nativeAppChallengesSchedule',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}challenges/challenge-schedule`,
      component : nativeAppChallengesSchedule,
      name      : 'nativeAppChallengesSchedule',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}challenges/leaderboard`,
      component : nativeAppChallengesLeaderboard,
      name      : 'nativeAppChallengesLeaderboard',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}challenges/faqs`,
      component : nativeAppChallengesFaq,
      name      : 'nativeAppChallengesFaqs',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}challenges/about`,
      component : nativeAppChallengesAbout,
      name      : 'nativeAppChallengesAbout',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
    },
    {
      path      : `${ROGUE_APP_SPA_URL_PREFIX}account/my-challenges`,
      component : accountMyChallenges,
      name      : 'nativeAppMyChallenges',
      meta      : {
        removeAboveHeader : true,
        removeCookieAgree : true,
        removeBanners     : true,
      },
      beforeEnter: async (to, from, next) => {
        const customerStore = useCustomerStore(rogue.pinia)
        await customerStore.init(rogue)
        next()
      },
    },
  ]
  routes.unshift({
    path      : '/events/:name/:year',
    component : competition,
    meta      : {
      wide        : true,
      defaultYear : 2025,
    },
  })
  routes.unshift({
    path      : '/events/:name/:year/:catchAll(.*)',
    component : competition,
    meta      : {
      wide        : true,
      defaultYear : 2025,
    },
  })
  routes.unshift({
    path      : '/order-manager-quote',
    component : orderManagerQuote,
    meta      : {
      isFunneled   : true,
      isAdminRoute : true,
      hideHeader   : true,
    },
  })

  routes.unshift({
    path      : '/checkout/success',
    component : checkoutSuccessV2,
    async beforeEnter() {
      const customerStore = useCustomerStore(rogue.pinia)
      await customerStore.init(rogue)
      const listStore = useListStore(rogue.pinia)
      await listStore.init(rogue)
    },
  })
  routes.unshift({
    path      : '/checkout',
    component : CheckoutV2,
    async beforeEnter() {
      const customerStore = useCustomerStore(rogue.pinia)
      await customerStore.init(rogue)
      const listStore = useListStore(rogue.pinia)
      await listStore.init(rogue)
    },
    children: [
      {
        path      : 'shipping',
        component : checkoutShippingV2,
        name      : 'shipping',
        meta      : {
          isFunneled: true,
        },
      },
      {
        path      : 'payment',
        component : checkoutPaymentV2,
        name      : 'payment',
        meta      : {
          isFunneled: true,
        },
      },
      {
        path      : 'review',
        component : checkoutReviewV2,
        name      : 'review',
        meta      : {
          isFunneled: true,
        },
      },
      {
        path      : '',
        component : checkoutLandingV2,
        name      : 'landing',
        meta      : {
          isFunneled: true,
        },
      },
    ],
  })

  let defaultYear = 2026
  try {
    defaultYear = Number(rogue.featureFlags.eval('invitational_year'))
  } catch (e) {
    console.warn('Error setting default year', e)
  }

  routes.unshift({
    path      : '/invitational',
    component : competition,
    meta      : {
      wide : true,
      year : defaultYear,
    },
  })

  routes.unshift({
    path      : '/invitational/:catchAll(.*)',
    component : competition,
    meta      : {
      wide : true,
      year : defaultYear,
    },
  })

  routes.unshift({
    path      : '/arnold-strongman-classic',
    component : competition,
    meta      : {
      wide : true,
      year : defaultYear,
    },
  })

  routes.unshift({
    path      : '/arnold-strongman-classic/:catchAll(.*)',
    component : competition,
    meta      : {
      wide : true,
      year : defaultYear,
    },
  })

  routes.push({
    path      : `/${['', 'rg', 'admin', ''].join('_')}/moderator/:eventId`,
    component : () => import(/* webpackChunkName: "admin_panel" */ 'Src/js/pages/admin/moderator.vue'),
  })

  if (rogue.site.code === 'USA') {
    routes.unshift(catalog)
    routes.unshift(...zeus)

    // The gym builder POC ships to staging behind a flag. Not registering the
    // route *is* the gate: with the flag off `/zeus-builder/poc` is not a route,
    // so it is unreachable and its chunk — Three.js, the engine, Rackbuilder's
    // forge — is never requested. Nothing about the POC costs anything while it
    // is off, which is what makes it safe to merge unfinished.
    //
    // Safe against hydration mismatch: the server passes its feature set into
    // `Rogue` before building routes and serialises the same set to
    // `window.ROGUE.features`, which the client passes in before building its
    // own — so both sides always agree on whether this route exists. Forced
    // flags (`?ab_enable-zeus-poc=1`, `cfab_` headers) are read server-side too,
    // so a per-request override flips both sides together.
    if (rogue.featureFlags.isOn('enable-zeus-poc')) {
      routes.unshift(zeusPoc)
    }
  }

  routes.unshift(rmaRoutes)

  routes.unshift({
    path      : '/rogue-equipped-gyms',
    component : rogueGyms,
    name      : 'Rogue Equipped Gyms',
  })

  return routes
}
